import { MenuItem, ListItemIcon, Icon } from '@liscio/ui';

import { GruntWorxExportStatusDialog } from '../../../../dialogs/GruntWorxExportStatusDialog';
import { useGruntWorxExport } from '../../../RequestsTableCells/RowMenuCell/hooks/useGruntWorxExport';

interface ExportGruntworxMenuItemProps {
  requestId: string;
}

export const ExportGruntworxMenuItem = ({
  requestId,
}: ExportGruntworxMenuItemProps) => {
  const {
    startExport,
    isExporting,
    exportStatus,
    pollAttempts,
    maxPollAttempts,
    retryExport,
    showStatusDialog,
    closeStatusDialog
  } = useGruntWorxExport();

  const handleExportGruntworxClick = async () => {
    if (requestId && requestId.trim() !== '') {
      await startExport(requestId);
    }
  };

  return (
    <>
      <MenuItem onClick={handleExportGruntworxClick}>
        <ListItemIcon>
          <Icon icon="upload" fontSize="small" />
        </ListItemIcon>
        Export to Gruntworx
      </MenuItem>

      {showStatusDialog && (
        <GruntWorxExportStatusDialog
          open={showStatusDialog}
          onClose={closeStatusDialog}
          exportStatus={exportStatus}
          pollAttempts={pollAttempts}
          maxPollAttempts={maxPollAttempts}
          isLoading={isExporting && !exportStatus}
          onRetry={() => requestId && retryExport(requestId)}
        />
      )}
    </>
  );
};
